import { ExternalApplicationWorkflowStore } from '@servicetitan/financing-application-workflow-shared';
import { PropsWithChildren } from 'react';
import { ExternalApplicationWorkflow } from '../features/workflow/ExternalApplicationWorkflow';

const externalApplicationWorkflows = {
    ExternalApplicationWorkflow,
};

export const ExternalApplicationWorkflowProvider = ({ children }: PropsWithChildren) => {
    return (
        <ExternalApplicationWorkflowStore.Provider initialState={externalApplicationWorkflows}>
            {children}
        </ExternalApplicationWorkflowStore.Provider>
    );
};
